import { useAuth } from '@//providers/AuthProvider';
import config from '@/config';
import { motion } from 'motion/react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AnimatedAccount from '../Animated/Icons/AnimatedAccount';
import OldLogoIcon from '../Icons/OldLogoIcon';

interface OldNavMenuProps {
  includeRole?: boolean;
  includeProfile?: boolean;
  includeLogo?: boolean;
  white?: boolean;
}

export default function OldNavMenu({
  includeRole = true,
  includeProfile = true,
  includeLogo: includeLogout = true,
  white = false
}: OldNavMenuProps) {
  const { userAttributes, groups, signOut } = useAuth();
  const [roleTitle, setRoleTitle] = useState('');

  useEffect(() => {
    if (groups.includes(config.admin.superAdminGroup)) {
      setRoleTitle('Superadmin');
    } else if (groups.includes(config.admin.adminGroup)) {
      setRoleTitle('Admin');
    } else if (groups.includes(config.admin.hostGroup)) {
      setRoleTitle('Host');
    }
  }, [groups]);

  return (
    <div className="px-64 w-full h-[80px] min-h-[80px] flex items-center underline-offset-3 relative z-50">
      <div className="w-full flex h-full justify-between items-center mt-[12px]">
        <motion.div
          initial={{ opacity: 0, y: -200 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -200 }}
          transition={{ type: 'spring', bounce: 0.3 }}
          className="w-full flex h-full justify-between items-center"
        >
          <div className="flex gap-6">
            {includeLogout && (
              <Link to="/dashboard" className="flex items-center max-w-144">
                <OldLogoIcon className={`${white ? 'text-white' : 'text-black'}`} />
              </Link>
            )}
            {roleTitle && includeRole && (
              <>
                <div className={`bg-black w-[2px]`}></div>
                <div className="text-3xl mb-4 flex flex-col justify-end leading-none">
                  {roleTitle}
                </div>
              </>
            )}
          </div>
          {includeProfile && (
            <div className="flex flex-row bg-gray-100 p-16 rounded-full">
              <Link
                to="/dashboard/profile"
                className="flex items-center stroke-black hover:text-pink-600 hover:stroke-pink-600 transition-colors"
              >
                <div className="flex items-center font-bold mr-8">
                  <AnimatedAccount />
                </div>
                <span className="mr-16 font-bold flex items-center">
                  {userAttributes?.given_name} {userAttributes?.family_name}
                </span>
              </Link>
              <button
                aria-label="Logout"
                className="btn bg-black text-white text-lg h-48 min-h-48 px-20"
                onClick={signOut}
              >
                Logout
              </button>
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
}
